import { useMemo } from "react";
import { useTotalCarbonEmissionsCard } from "queries/BuildingReport/Project/useTotalCarbonEmissionsCard";
import { Header } from "components/atoms/Typography";
import { CardErrorState } from "components/molecules/ErrorStates";
import { useTotalEnergyConsumptionCard } from "queries/BuildingReport/Project/useTotalEnergyConsumptionCard";
import ProjectCardSection from "./ProjectCardSection";
import { buildTotalCarbonEmissionSavingsCardStruct, LargeCardLoading } from "../ProjectsReport.helper";

interface TotalCarbonEmissionsCardProps {
    measure: CarbonReductionMeasure;
}

function TotalCarbonEmissionsAndEnergyCard({ measure }: TotalCarbonEmissionsCardProps) {
    const {
        data: carbonEmissionsData,
        isLoading: carbonEmissionsLoading,
        isError: carbonEmissionsError,
    } = useTotalCarbonEmissionsCard(measure.carbonReductionMeasureUid);

    const {
        data: energyData,
        isLoading: energyLoading,
        isError: energyError,
    } = useTotalEnergyConsumptionCard(measure.carbonReductionMeasureUid);

    const cardData = useMemo(() => {
        if (!carbonEmissionsData || !energyData) return undefined;
        return buildTotalCarbonEmissionSavingsCardStruct(carbonEmissionsData, energyData);
    }, [carbonEmissionsData, energyData]);

    if (carbonEmissionsError || energyError) return <CardErrorState />;
    if (energyLoading || carbonEmissionsLoading || !cardData) return <LargeCardLoading />;

    return (
        <div className="large-card">
            <Header size="small">Energy & Emissions savings</Header>
            {cardData.map((section) => (
                <ProjectCardSection key={section.title.key} data={section} />
            ))}
        </div>
    );
}

export default TotalCarbonEmissionsAndEnergyCard;
